module.exports = __webpack_public_path__ + "img/openai.67826939.svg";